/*
 * @Author: JamesWong
 * @Description: 副屏幕中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 16:53:31
 */
export default {
  interactMode: 'Interact Mode',
  rollingPhotos: 'Rolling Display Photos',
  advertisementVideo: 'Advertisement Video',
  interactModeTips1: '1. When cashier machine is not collecting money, sub-screen rolling display Photo/Video in full-screen',
  interactModeTips2: '2. During cashier, sub-screen displays Photo/Video on the left side, and Sales Detail and trade amount on the right side',
  interactModeTips3: '3. After closing counting, sub-screen return to full-screen mode',
  fullscreenPhoto: 'Full-screen Photo',
  fullscreenVideo: 'Full-screen Video',
  photoSalesDetail: 'Photo + Sales Detail',
  videoSalesDetail: 'Video + Sales Detail',
  upload: 'Upload',
  preview: 'Preview',
  previewPhotos: 'Preview Photos',
  delete: 'Delete',
  photoDeleted: 'Photo Deleted!',
  previewVideo: 'Preview Video',
  videoUploaded: 'Video Uploaded!',
  videoSizeTips: 'File size can not exceed 200M!',
  photoUploaded: 'Photo Uploaded!',
  phoneSizeTips: 'File size can not exceed 10M!',
  longNameTips: 'File name cannot too long!',
  moreFileTips: 'Can only upload a video, please delete the original one to try again!',
  uploadingTips: 'The file is uploaded...   Pls wait',
  notSupportTips: 'Your browser does not support video tag',
  uploadProgress: 'Upload progress',
  noVideoTips: 'You have not uploaded video, please upload.',
  noPhotoTips: 'You have not uploaded photo, please upload.',
  Unnamed: 'Unnamed'
}


// WEBPACK FOOTER //
// ./src/i18n/en/screen.js